<template>
  <v-notification
    :type="notification.type"
    :value="notification.status"
    @input="setNotification({ status: false })">
    {{ notification.message }}
  </v-notification>
</template>

<script>
import VNotification from '@/components/base/VNotification'
import { mapState, mapMutations } from 'vuex'

export default {
  components: { VNotification },
  computed: {
    ...mapState("app", ["notification"])
  },
  methods: {
    ...mapMutations("app", ["setNotification"])
  }
}
</script>

<style scoped>
@media print {
  article {
    display: none;
  }
}

article {
  z-index: 41;
}
</style>
